/* Dabrana · cart drawer add-on (this filename is the one already referenced by layout/theme.liquid).
   Buy 2 Get 2 Free — make the automatic discount visible in the cart drawer.
   The discount itself is a Shopify automatic BXGY rule (store-level), so /cart.js already
   returns discounted totals. This only surfaces it: a savings line in the drawer footer,
   struck-through original prices on discounted lines, and a nudge when the customer is
   short of qualifying. Painted by observation so the drawer's own renderer is untouched. */
(function () {
  var NEED = 4;                 // bottles needed for the offer (buy 2, get 2)
  var GIFT_TYPE = 'Tester';
  var timer = null, last = '';

  function money(p) {
    try { return '\u20B9' + new Intl.NumberFormat('en-IN').format(Math.round(p / 100)); }
    catch (e) { return '\u20B9' + Math.round(p / 100); }
  }

  function style() {
    if (document.getElementById('dab-b2g2-css')) return;
    var st = document.createElement('style');
    st.id = 'dab-b2g2-css';
    st.textContent =
      '#dab-cart .dab-b2g2{display:flex;align-items:center;justify-content:space-between;gap:10px;margin:0 0 14px;padding:10px 13px;border:1px solid rgba(201,161,90,.4);border-radius:6px;background:linear-gradient(180deg,rgba(201,161,90,.13),rgba(201,161,90,.04));font-family:var(--font-sans,Jost,Inter,sans-serif);font-size:11px;letter-spacing:.13em;text-transform:uppercase;color:#EAD9A9}'
      + '#dab-cart .dab-b2g2 b{font-weight:700;color:var(--gold,#C9A15A);letter-spacing:.06em;white-space:nowrap}'
      + '#dab-cart .dab-b2g2--nudge{border-style:dashed;border-color:rgba(201,161,90,.3);background:none;color:#9a8f7d}'
      + '#dab-cart .dab-b2g2--nudge b{color:#EAD9A9}'
      + '#dab-cart .dab-cart__price s{display:block;color:#8a8072;font-size:12px;text-decoration-thickness:1px;margin-bottom:2px}';
    (document.head || document.documentElement).appendChild(st);
  }

  function paint(cart) {
    var foot = document.querySelector('#dab-cart .dab-cart__foot');
    if (!foot || foot.hidden) { last = ''; return; }

    var bottles = 0, byKey = {};
    (cart.items || []).forEach(function (it) {
      if (it.product_type !== GIFT_TYPE) bottles += it.quantity;
      byKey[it.key] = it;
    });
    var saved = cart.total_discount || 0;

    var html = '';
    if (saved > 0) html = '<div class="dab-b2g2"><span>Buy 2 Get 2 Free applied</span><b>\u2212 ' + money(saved) + '</b></div>';
    else if (bottles > 0 && bottles < NEED) html = '<div class="dab-b2g2 dab-b2g2--nudge"><span>Add <b>' + (NEED - bottles) + '</b> more \u2014 get 2 free</span></div>';

    var sig = html + '|' + Object.keys(byKey).map(function (k) { return k + ':' + byKey[k].original_line_price + ':' + byKey[k].final_line_price; }).join(',');
    if (sig === last) return;
    last = sig;

    var row = foot.querySelector('.dab-b2g2');
    if (!html) { if (row) row.parentNode.removeChild(row); }
    else if (row) row.outerHTML = html;
    else foot.insertAdjacentHTML('afterbegin', html);

    /* struck-through original on any line the discount touched */
    var lines = document.querySelectorAll('#dab-cart .dab-cart__line');
    for (var i = 0; i < lines.length; i++) {
      var it = byKey[lines[i].getAttribute('data-key') || ''];
      var el = lines[i].querySelector('.dab-cart__price');
      if (!it || !el || lines[i].getAttribute('data-dabgift')) continue;
      var was = el.querySelector('s');
      if (it.final_line_price < it.original_line_price) {
        if (!was) el.insertAdjacentHTML('afterbegin', '<s>' + money(it.original_line_price) + '</s>');
        else was.textContent = money(it.original_line_price);
      } else if (was) was.parentNode.removeChild(was);
    }
  }

  function run() {
    var d = document.getElementById('dab-cart');
    if (!d || !d.classList.contains('is-open')) { last = ''; return; }
    fetch('/cart.js?b2g2=1', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(paint).catch(function () {});
  }

  function schedule() { clearTimeout(timer); timer = setTimeout(run, 180); }

  function start() {
    style();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    schedule();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* Dabrana · tactile purchase feedback: a bold squash-and-pop bounce on Add to Cart / Buy Now
   plus a burst of small gold STARS out of the button, then a smaller second burst on the header
   cart icon ~190ms later so the eye is led from the button up to the bag. Appended to this file
   because theme.liquid already loads it sitewide, so no new asset and no layout edit are
   needed. The canvas is created on demand and removed the instant the last particle dies. */
(function () {
  var SR = '[id*="fastrr"],[class*="fastrr"],[id*="shiprocket"],[class*="shiprocket"],[class*="sr-checkout"],[class*="srCheckout"]';
  var ICO = '.dh-head a[aria-label="Cart"],.dh-head__ico a[href^="/cart"],header a[aria-label="Cart"],header a[href="/cart"]';
  var INK = ['#C9A15A', '#EAD9A9', '#F0D79A', '#F6EFE2', '#B98D45', '#8C6B33'];
  var cv = null, ctx = null, parts = [], raf = 0, dpr = 1, fired = 0;

  function calm() { try { return matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; } }

  function burstCss() {
    if (document.getElementById('dab-burst-css')) return;
    var st = document.createElement('style');
    st.id = 'dab-burst-css';
    st.textContent =
      '@keyframes dabPop{0%{transform:scale(1)}16%{transform:scale(.90,.86)}40%{transform:scale(1.11,1.14)}62%{transform:scale(.96,.97)}80%{transform:scale(1.04,1.03)}100%{transform:scale(1)}}'
      + '@keyframes dabPopWide{0%{transform:scale(1)}16%{transform:scale(.985,.90)}40%{transform:scale(1.014,1.10)}62%{transform:scale(.996,.975)}80%{transform:scale(1.005,1.02)}100%{transform:scale(1)}}'
      + '@keyframes dabPopIco{0%{transform:scale(1)}18%{transform:scale(.80)}44%{transform:scale(1.4)}66%{transform:scale(.93)}82%{transform:scale(1.07)}100%{transform:scale(1)}}'
      + '.dab-pop{animation:dabPop .52s cubic-bezier(.34,1.56,.64,1) both;will-change:transform}'
      + '.dab-pop--wide{animation-name:dabPopWide}'
      + '.dab-pop--ico{animation:dabPopIco .6s cubic-bezier(.34,1.56,.64,1) both;transform-origin:50% 50%;will-change:transform}'
      + '#dab-burst{position:fixed;inset:0;pointer-events:none;z-index:2147483600}'
      + '@media(prefers-reduced-motion:reduce){.dab-pop{animation-duration:.22s;animation-timing-function:ease-out}.dab-pop--ico{animation-duration:.26s}}';
    (document.head || document.documentElement).appendChild(st);
  }

  function fit() {
    if (!cv) return;
    dpr = Math.min(window.devicePixelRatio || 1, 2);
    cv.width = Math.round(innerWidth * dpr);
    cv.height = Math.round(innerHeight * dpr);
    cv.style.width = innerWidth + 'px';
    cv.style.height = innerHeight + 'px';
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }

  /* five-pointed star, centred on the current origin. r is the outer radius in CSS px — these
     are deliberately tiny (roughly 2–5px) so the burst reads as a sparkle, not as party foil. */
  function star(g, r) {
    g.beginPath();
    for (var i = 0; i < 10; i++) {
      var a = -Math.PI / 2 + i * Math.PI / 5;
      var rad = (i % 2) ? r * 0.44 : r;
      g.lineTo(Math.cos(a) * rad, Math.sin(a) * rad);
    }
    g.closePath();
    g.fill();
  }

  function tick() {
    ctx.clearRect(0, 0, innerWidth, innerHeight);
    for (var i = parts.length - 1; i >= 0; i--) {
      var p = parts[i];
      p.vy += 0.34; p.vx *= 0.985; p.vy *= 0.992;
      p.x += p.vx; p.y += p.vy; p.r += p.vr; p.life++;
      var t = p.life / p.max;
      if (t >= 1 || p.y > innerHeight + 60) { parts.splice(i, 1); continue; }
      ctx.save();
      ctx.globalAlpha = t > 0.72 ? 1 - (t - 0.72) / 0.28 : 1;
      ctx.translate(p.x, p.y);
      ctx.rotate(p.r);
      ctx.fillStyle = p.c;
      if (p.dot) { ctx.beginPath(); ctx.arc(0, 0, p.s * 0.38, 0, 6.2832); ctx.fill(); }
      else star(ctx, p.s);
      ctx.restore();
    }
    if (parts.length) { raf = requestAnimationFrame(tick); return; }
    raf = 0;
    removeEventListener('resize', fit);
    if (cv && cv.parentNode) cv.parentNode.removeChild(cv);
    cv = null; ctx = null;
  }

  function burst(x, y, spread, count, power) {
    if (!cv) {
      cv = document.createElement('canvas');
      cv.id = 'dab-burst';
      cv.setAttribute('aria-hidden', 'true');
      document.body.appendChild(cv);
      ctx = cv.getContext('2d');
      fit();
      addEventListener('resize', fit, { passive: true });
    }
    var pw = power || 1;
    var n = count || Math.min(90, Math.round(48 + spread * 0.1));
    for (var i = 0; i < n; i++) {
      var a = -Math.PI / 2 + (Math.random() - 0.5) * 2.4;
      var sp = (5 + Math.random() * 11) * pw;
      var dot = Math.random() < 0.22;              /* a little dust among the stars */
      parts.push({
        x: x + (Math.random() - 0.5) * spread * 0.72,
        y: y,
        vx: Math.cos(a) * sp * 1.3,
        vy: Math.sin(a) * sp,
        s: (2.2 + Math.random() * 2.6) * (pw < 1 ? 0.8 : 1),
        r: Math.random() * Math.PI,
        vr: (Math.random() - 0.5) * 0.42,
        c: INK[(Math.random() * INK.length) | 0],
        dot: dot, life: 0, max: 54 + Math.random() * 36
      });
    }
    if (!raf) raf = requestAnimationFrame(tick);
  }

  function pop(el, extra) {
    el.classList.remove('dab-pop', 'dab-pop--wide', 'dab-pop--ico');
    el.getBoundingClientRect();               /* force a reflow so a repeat click replays it */
    el.classList.add(extra || 'dab-pop');
    el.addEventListener('animationend', function done() {
      el.classList.remove('dab-pop', 'dab-pop--wide', 'dab-pop--ico');
      el.removeEventListener('animationend', done);
    });
  }

  /* Second, smaller burst on the header bag. The icon is an <a aria-label="Cart"> in
     snippets/dab-header.liquid, inlined again into dab-home/product/collection/page, so more
     than one may exist in the DOM — animate the first one actually on screen. The <svg> is
     scaled rather than the <a>, because the anchor sits in the header's flex row and giving it
     its own transform context would nudge the neighbouring icons. */
  function bag() {
    var list = document.querySelectorAll(ICO);
    for (var i = 0; i < list.length; i++) {
      var r = list[i].getBoundingClientRect();
      if (r.width && r.bottom > 0 && r.top < innerHeight) return list[i];
    }
    return null;
  }

  function celebrateBag() {
    var a = bag();
    if (!a) return;
    var r = a.getBoundingClientRect();
    pop(a.querySelector('svg') || a, 'dab-pop--ico');
    if (!calm()) burst(r.left + r.width / 2, r.top + r.height * 0.5, 26, 22, 0.55);
  }
  window.__dabCelebrateBag = celebrateBag;

  /* Which element counts as a purchase button. Label-based on purpose: sections/dab-product.liquid
     is 121KB of markup with no stable ATC class, and the same copy is reused by the sticky bar,
     the PDP and the collection cards. Fastrr's own buttons and the drawer are excluded so we
     never animate — or interfere with — the Shiprocket checkout. */
  function hit(node) {
    if (!node || !node.closest) return null;
    if (node.closest(SR) || node.closest('#dab-cart')) return null;
    var el = node.closest('button,a,input[type=submit],input[type=button],[role=button]');
    if (!el) return null;
    var t = (el.textContent || el.value || '').replace(/\s+/g, ' ').trim().toUpperCase();
    if (t.indexOf('POWERED BY') > -1) return null;
    if (el.name === 'add' || el.hasAttribute('data-atc') || /^(ADD TO CART|ADD TO BAG|BUY NOW)/.test(t)) return el;
    return null;
  }

  document.addEventListener('click', function (e) {
    if (!e.isTrusted) return;   /* dab-gift.js re-clicks Add to Cart programmatically for Buy Now */
    var el = hit(e.target);
    if (!el) return;
    var now = Date.now();
    if (now - fired < 450) return;
    fired = now;
    burstCss();
    var r = el.getBoundingClientRect();
    pop(el);
    if (r.width > 380) el.classList.add('dab-pop--wide');
    if (!calm() && r.width) burst(r.left + r.width / 2, r.top + r.height * 0.45, Math.min(r.width, 340));
    setTimeout(celebrateBag, 190);
  }, true);
})();

/* Dabrana · Add to Cart stays on the product page — no navigation, and no drawer either.

   The drawer script (assets/dab-fixes.js) listens for the add-to-cart form's submit but never
   cancels it, so the browser performed the real POST to /cart/add, Shopify answered with a
   redirect to the full /cart page, and the drawer was then opened on that freshly loaded page.

   Fix here rather than in dab-fixes.js (84KB): cancel the submit in the CAPTURE phase and add
   via /cart/add.js. Capture runs before dab-fixes.js's bubble-phase listener regardless of
   script order, and stopImmediatePropagation is what stops that listener from opening the
   drawer 480ms later. The only feedback is the button bounce, the star burst, and the header
   bag count ticking up — the customer keeps reading the product.

   ⚠ The bag count badge is re-created here with the same markup dab-fixes.js uses
   (.dab-cart-count), because its own updateBadge() is private to the drawer's closure and only
   runs when the drawer opens. Keep the two in sync if either changes.

   ⚠ Fastrr/Shiprocket only replaces the DRAWER's checkout button. With the drawer no longer
   opening on add, the customer reaches it by tapping the bag — or uses Buy Now, which
   dab-gift.js still routes into the drawer deliberately. */
(function () {
  var SR = '[id*="fastrr"],[class*="fastrr"],[id*="shiprocket"],[class*="shiprocket"],[class*="sr-checkout"],[class*="srCheckout"]';
  var BADGE = 'position:absolute;top:-6px;right:-8px;min-width:16px;height:16px;padding:0 4px;background:var(--accent,#C9A15A);color:#0B0A08;border-radius:999px;font:600 10px/16px Inter,system-ui,sans-serif;text-align:center;box-sizing:border-box;pointer-events:none';

  function setBadge(n) {
    var list = document.querySelectorAll('a[href="/cart"],a[href$="/cart"],a[aria-label="Cart"]');
    for (var i = 0; i < list.length; i++) {
      var a = list[i];
      if (a.classList.contains('dab-cart__view')) continue;
      if (getComputedStyle(a).position === 'static') a.style.position = 'relative';
      var b = a.querySelector('.dab-cart-count');
      if (!n) { if (b) b.parentNode.removeChild(b); continue; }
      if (!b) {
        b = document.createElement('span');
        b.className = 'dab-cart-count';
        b.style.cssText = BADGE;
        a.appendChild(b);
      }
      b.textContent = n;
    }
  }

  function syncBadge() {
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { setBadge((c && c.item_count) || 0); })
      .catch(function () {});
  }
  window.__dabSyncBadge = syncBadge;

  function isAddForm(f) {
    var action = f.getAttribute('action') || '';
    return /\/cart\/add/.test(action) || !!f.querySelector('[name="add"]');
  }

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || f.tagName !== 'FORM' || !isAddForm(f)) return;
    if (f.closest(SR) || f.closest('#dab-cart')) return;

    /* the PDP's own Buy Now button posts this form itself and routes to Shiprocket — leave it */
    var sub = e.submitter || (document.activeElement && document.activeElement.form === f ? document.activeElement : null);
    if (sub && sub.id === 'pdp-buynow') return;

    e.preventDefault();
    e.stopImmediatePropagation();
    if (f.__dabAdding) return;
    f.__dabAdding = true;

    var btn = (sub && sub.name === 'add') ? sub : f.querySelector('[name="add"]');
    var was = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    function restore() {
      f.__dabAdding = false;
      if (!btn) return;
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
      btn.innerHTML = was;
    }

    var fd = new FormData(f);
    try { fd.delete('return_to'); } catch (err) {}   /* would make Shopify redirect anyway */

    fetch('/cart/add.js', {
      method: 'POST', body: fd, credentials: 'same-origin',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function (r) {
      return r.json().then(function (j) { return { ok: r.ok, data: j }; },
                           function () { return { ok: r.ok, data: null }; });
    }).then(function (res) {
      if (res.ok) {
        /* the toast + ✓ label used to come from dab-cinematic.js's own add handler, which was
           removed because it was adding the item a second time. Same feedback, one add. */
        f.__dabAdding = false;
        if (btn) {
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
          btn.innerHTML = 'Added \u2713';
          setTimeout(function () { btn.innerHTML = was; }, 1600);
        }
        if (window.__dabToast) { try { window.__dabToast('Added to cart'); } catch (err) {} }
        syncBadge();
        return;
      }
      restore();
      /* sold out, or the variant went unavailable while the page was open */
      if (btn) {
        btn.innerHTML = 'Unavailable';
        setTimeout(function () { btn.innerHTML = was; }, 2200);
      }
    }).catch(function () {
      /* offline or blocked: fall back to the plain form post so the add still happens */
      restore();
      if (typeof HTMLFormElement !== 'undefined') HTMLFormElement.prototype.submit.call(f);
    });
  }, true);
})();

/* Dabrana · scent profiler icon, mobile only.

   Three files were each styling this one link on small screens, and they contradicted:
     · dab-home.css       — absolute at left:10px, its own border box, "New" pill floating
                             above the header edge at top:-7px
     · dab-cinematic.js   — shoves it to left:50px !important to clear the hamburger
     · dab-fixes.js       — forces .dh-head__profiler-main to flex-direction:column
   Net effect on a real phone: an oversized labelled block colliding with the hamburger on one
   side and the centred DABRANA logo on the other.

   Hard-coded pixel offsets were tried twice and missed twice — the hamburger's width, the
   logo's rendered width and the header's padding all differ per template and per device, so
   any single `left:` value is a guess. So MEASURE instead: read the right edge of the menu
   button and the left edge of the logo, then centre the profiler in the gap that actually
   exists, capped to fit inside it. Re-measured on resize, orientation change and after the
   logo image and webfonts land (all of which move the logo's edge).

   Styling still has to be injected from JS rather than dab-home.css: dab-cinematic.js and
   dab-fixes.js add their !important rules at runtime, so a stylesheet edit loses on source
   order. These selectors carry TWO classes (.dh-head .dh-head__profiler) against their one,
   so they win regardless of order.

   ⚠ THE ANTI-FLASH GATE LIVES IN dab-home.css, NOT HERE. That stylesheet is render-blocking
     and loads before the header paints, so it hides the profiler on mobile until this script
     adds .dab-prof-ready. Without it the browser paints dab-home.css's own left:10px bordered
     version for a frame before this file is even fetched — which is exactly the reload glitch.
     If the gate is ever removed from dab-home.css, the flash returns.
   ⚠ The tag is IN FLOW (position:static) inside the column, not absolutely positioned above
     the anchor — that is what stopped it hanging over the header's top edge.
   ⚠ The text label stays hidden on mobile; icon + "New" is the whole affordance. Showing it is
     what made the block wide enough to collide in the first place.
   ⚠ If the measured gap is under 30px the profiler is hidden rather than overlapped — better
     absent than printed over the logo. Desktop is deliberately untouched. */
(function () {
  var MQ = '(max-width:600px)';
  var HAM = '.dab-ham,.dh-head__ham,.dh-ham,[aria-label="Menu"],[aria-label="menu"]';
  var LOGO = '.dh-logo,.dh-head__logo';

  if (!document.getElementById('dab-profiler-css')) {
    var st = document.createElement('style');
    st.id = 'dab-profiler-css';
    st.textContent = '@media(max-width:600px){'
      /* left/width are set per-header by place(); the fallbacks only apply before it runs */
      + '.dh-head .dh-head__profiler{position:absolute!important;left:var(--dab-prof-x,46px)!important;right:auto!important;top:50%!important;bottom:auto!important;transform:translateY(-50%)!important;display:inline-flex!important;flex-direction:column!important;align-items:center!important;justify-content:center!important;gap:2px!important;width:auto!important;max-width:var(--dab-prof-w,40px)!important;padding:2px!important;margin:0!important;border:0!important;background:none!important;border-radius:8px!important;overflow:visible!important;z-index:2!important}'
      + '.dh-head .dh-head__profiler[hidden]{display:none!important}'
      /* "New" stays visible, in flow, above the icon — just sized to belong there */
      + '.dh-head .dh-head__profiler-tag{position:static!important;display:inline-block!important;top:auto!important;left:auto!important;right:auto!important;bottom:auto!important;transform:none!important;width:auto!important;height:auto!important;min-width:0!important;padding:1px 4px!important;margin:0!important;border-radius:999px!important;font-size:6px!important;line-height:1.6!important;letter-spacing:.12em!important;text-indent:0!important;white-space:nowrap!important;overflow:visible!important}'
      + '.dh-head .dh-head__profiler-main{flex-direction:row!important;align-items:center!important;justify-content:center!important;gap:0!important}'
      + '.dh-head .dh-head__profiler-main span{display:none!important}'
      + '.dh-head .dh-head__profiler-main svg{width:16px!important;height:16px!important;flex:0 0 auto!important}'
      + '}';
    (document.head || document.documentElement).appendChild(st);
  }

  function place() {
    var small;
    try { small = matchMedia(MQ).matches; } catch (e) { small = innerWidth <= 600; }

    var heads = document.querySelectorAll('.dh-head');
    for (var i = 0; i < heads.length; i++) {
      var head = heads[i];
      var p = head.querySelector('.dh-head__profiler');
      if (!p) continue;
      if (!small) {                    /* leave desktop exactly as authored */
        p.removeAttribute('hidden');
        p.classList.add('dab-prof-ready');
        p.style.removeProperty('--dab-prof-x');
        p.style.removeProperty('--dab-prof-w');
        continue;
      }

      var hr = head.getBoundingClientRect();
      if (!hr.width) continue;         /* an inline duplicate that isn't rendered */

      var ham = head.querySelector(HAM) || document.querySelector(HAM);
      var logo = head.querySelector(LOGO);
      var from = ham ? ham.getBoundingClientRect().right : hr.left + 42;
      var to = logo ? logo.getBoundingClientRect().left : hr.left + 130;

      var gap = to - from;
      if (gap < 30) { p.setAttribute('hidden', ''); continue; }
      p.removeAttribute('hidden');

      var w = Math.max(24, Math.min(40, gap - 12));
      p.style.setProperty('--dab-prof-w', w + 'px');
      p.style.setProperty('--dab-prof-x', Math.round(from - hr.left + (gap - w) / 2) + 'px');
      /* only now is it safe to show: released from the dab-home.css gate */
      p.classList.add('dab-prof-ready');
    }
  }

  function watch() {
    place();
    /* the logo is an <img> and the header uses a webfont — both move `to` after first paint */
    addEventListener('load', place);
    addEventListener('resize', place, { passive: true });
    addEventListener('orientationchange', place);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(place).catch(function () {});
    setTimeout(place, 400);
    setTimeout(place, 1600);          /* after the splash releases the header */
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
})();

/* Dabrana · rupee prices, written the way a customer expects.

   ROOT CAUSE, not a theme bug: Settings → Store details has the money format set to
   "Rs. {{amount}}", so every Liquid `money` filter in the theme renders "Rs. 1,111.00" /
   "Rs. 1,111" — on the PDP price, inside the Add to Cart label, in the sticky bar, on the
   collection cards and in search results. The real one-field fix is to change that setting to
   "₹{{amount_no_decimals}}" (it also fixes checkout, emails and the Shopify-rendered /cart
   page, which this script cannot reach). Until then, normalise what the storefront prints:

     Rs. 1,111.00  →  ₹1,111
     Rs 1111       →  ₹1,111
     INR 1,111.00  →  ₹1,111
     ₹1,111.00     →  ₹1,111      (already-rupee prices lose the dead decimals too)

   Kept as a text-node pass rather than a Liquid edit because the price is printed in a dozen
   places across sections/dab-product.liquid (121KB), dab-collection.liquid and the four
   templates that inline their own card markup — one function here covers all of them and the
   JS-rendered drawer as well.

   SECOND, SEPARATE DEFECT, visible in the customer's screenshot: the PDP price is set in the
   serif (Cormorant), whose default figures are OLD-STYLE — 1,111 draws as short humanist
   glyphs that read as "I,III", which is what "written very weirdly" meant. Prices are data,
   not prose, so every price element is forced to LINING + TABULAR figures. Injected here
   beside the currency pass so both halves of the problem live in one place.

   ⚠ Non-zero paise are preserved (1,111.50 stays), only ".00" is dropped.
   ⚠ Fastrr/Shiprocket subtrees are skipped — never rewrite a payment provider's own UI.
   ⚠ `busy` guards the observer: rewriting text fires characterData mutations, and without the
     flag the pass would re-enter itself. The pass is idempotent, so a settled DOM does nothing. */
(function () {
  var SKIP = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, CODE: 1, PRE: 1, OPTION: 1 };
  var SR = '[id*="fastrr"],[class*="fastrr"],[id*="shiprocket"],[class*="shiprocket"],[class*="sr-checkout"],[class*="srCheckout"]';
  var RS = /(?:\bRs\.?|\bINR)\s*(\d[\d,]*)(\.\d{1,2})?/g;
  var ZERO = /\u20B9\s*(\d[\d,]*)\.00\b/g;
  var busy = false, timer = null;

  /* prices are numerals, not text: lining + tabular so 1,111 reads as 1,111 in the serif */
  if (!document.getElementById('dab-price-css')) {
    var st = document.createElement('style');
    st.id = 'dab-price-css';
    st.textContent =
      '.pdp-amount,.pdp-mrp,.pdp-price,.pdp-sticky__price,.pdp-add,.pdp-offer,.dh-card__price,'
      + '.dh-price,.dab-cart__price,.dab-cart__total,#dab-cart .dab-b2g2 b,.pdp-bundle__total,'
      + '.pdp-perbottle,.price,.money'
      + '{font-variant-numeric:lining-nums tabular-nums!important;'
      + 'font-feature-settings:"lnum" 1,"tnum" 1,"onum" 0!important;font-kerning:normal}'
      /* the big PDP figure also sat slightly loose once the glyphs changed height */
      + '.pdp-amount{letter-spacing:.01em}';
    (document.head || document.documentElement).appendChild(st);
  }

  /* group digits Indian-style, but only when the source had no separators of its own */
  function groups(n) {
    if (n.indexOf(',') > -1) return n;
    if (n.length < 4) return n;
    var head = n.slice(0, -3), tail = n.slice(-3);
    return head.replace(/\B(?=(\d\d)+$)/g, ',') + ',' + tail;
  }

  function fix(s) {
    return s
      .replace(RS, function (m, n, d) {
        return '\u20B9' + groups(n) + (d && d !== '.00' && d !== '.0' ? d : '');
      })
      .replace(ZERO, '\u20B9$1');
  }

  function pass(root) {
    if (busy) return;
    busy = true;
    try {
      var walk = document.createTreeWalker(root || document.body, NodeFilter.SHOW_TEXT, null);
      var hits = [], t;
      while ((t = walk.nextNode())) {
        var v = t.nodeValue;
        if (!v || v.length > 4000) continue;
        if (v.indexOf('Rs') < 0 && v.indexOf('INR') < 0 && v.indexOf('\u20B9') < 0) continue;
        var p = t.parentNode;
        if (!p || SKIP[p.nodeName]) continue;
        if (p.closest && p.closest(SR)) continue;
        var out = fix(v);
        if (out !== v) hits.push([t, out]);
      }
      for (var i = 0; i < hits.length; i++) hits[i][0].nodeValue = hits[i][1];
    } catch (e) {}
    busy = false;
  }

  function queue() { clearTimeout(timer); timer = setTimeout(function () { pass(); }, 60); }

  function start() {
    pass();
    new MutationObserver(queue).observe(document.body, { childList: true, subtree: true, characterData: true });
    addEventListener('load', queue);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
